import React from "react";
import { blogCaptionClasses, StyledBlogCaption } from "./StyledBlogCaption";
import { Container, Grid, Typography } from "@mui/material";

import rightArrow from "./images/right-arrow.png";

import { IBlog } from "../IBlog";
import { blogs } from "../blog-items";
import { useNavigate } from "react-router-dom";
import { NavigationRoutes } from "../../routes";

const getNextBlog = (blog: IBlog): IBlog | undefined => {
  const currentBlogIndex = blogs.findIndex((b) => b.slug === blog.slug);
  if (currentBlogIndex < 0 || blogs.length < 2) {
    return undefined;
  }
  const nextBlog = blogs[currentBlogIndex + 1] || blogs[0];
  return nextBlog.slug === blog.slug ? undefined : nextBlog;
};

export const BlogNext = ({ blog }: { blog: IBlog }) => {
  const nextBlog = getNextBlog(blog);
  const navigate = useNavigate();

  if (!nextBlog) {
    return null;
  }

  return (
    <div className={blogCaptionClasses.nextStory}>
      <Typography className={blogCaptionClasses.nextStoryText}>
        Next Blog
      </Typography>
      <div className={blogCaptionClasses.nextStoryCountry}>
        <Typography>{nextBlog.title}</Typography>
      </div>
      <div className={blogCaptionClasses.circle} onClick={() => {
        navigate(`/${NavigationRoutes.SinlgeBlog}/${nextBlog.slug}`)
      }}>
        <img src={rightArrow} alt="Arrow" />
      </div>
    </div>
  );
};

export const BlogNextMobile = ({ blog }: { blog: IBlog }) => {
  if (!getNextBlog(blog)) {
    return null;
  }

  return (
    <StyledBlogCaption className={`${blogCaptionClasses.root} ${blogCaptionClasses.nextStoryMobile}`}>
      <Container>
        <BlogNext blog={blog} />
      </Container>
    </StyledBlogCaption>
  );
};

export const BlogCaption = ({ blog }: { blog: IBlog }) => {

  return (
    <StyledBlogCaption className={blogCaptionClasses.root + " gradient--down gradient--down--full"}>
      <Container>
        <Grid container>
          {/* Title - Full Width */}
          <Grid item lg={12}>
            <Grid
              item
              container
              flexDirection="column"
              alignItems="baseline"
              justifyContent="space-between"
              sx={{ margin: "40px 0" }}
              lg={12}>
              <div className={blogCaptionClasses.sixtySecondsCountry}>
                <div>
                  <Typography variant={"h2"} sx={{ 
                    lineHeight: {
                      xs: "32px!important",
                      md: "42px!important",
                      lg: "52px!important",
                    }, 
                    fontSize: {
                      xs: "24px",
                      md: "32px",
                      lg: "42px",
                    }
                    }}>
                    {blog.title}
                  </Typography>
                  {blog.subheader && (
                    <Typography 
                      variant="body1" 
                      component="div"
                      sx={{ 
                        marginTop: {
                          xs: "16px",
                          md: "20px",
                          lg: "24px",
                        },
                        fontSize: {
                          xs: "14px",
                          md: "16px",
                          lg: "18px",
                        },
                        lineHeight: {
                          xs: "22px",
                          md: "26px",
                          lg: "30px",
                        },
                        color: "#000000 !important",
                      }}
                    >
                      {blog.subheader}
                    </Typography>
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
          
          <Grid item lg={6} className={blogCaptionClasses.leftCol}>
            <img
              src={blog.image}
              alt=""
              className={blogCaptionClasses.countryImage}
              width={680}
            />
            {(blog.reading_time || blog.publishedDate) && (
              <Typography 
                variant="body2" 
                component="div"
                sx={{ 
                  marginTop: "16px",
                  fontSize: "16px",
                  lineHeight: "24px",
                  color: "#000000!important",
                  display: "flex",
                  gap: "12px",
                  flexWrap: "wrap",
                }}
              >
                {blog.publishedDate && (
                  <span className={blogCaptionClasses.metaText}>
                    {new Date(blog.publishedDate).toLocaleDateString('en-GB', {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric'
                    })}
                  </span>
                )}
                {blog.reading_time && blog.publishedDate && (
                  <span className={blogCaptionClasses.metaText}>•</span>
                )}
                {blog.reading_time && (
                  <span className={blogCaptionClasses.metaText}>{blog.reading_time} read</span>
                )}
              </Typography>
            )}
          </Grid>
          
          <Grid item lg={6} className={blogCaptionClasses.rightCol}>
            <BlogNext blog={blog} />
          </Grid>
        </Grid>
      </Container>
    </StyledBlogCaption>
  );
};
